module.exports = __webpack_public_path__ + "img/Credencial-B.2cc44db1.svg";